// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3knPl","header":"MergedInvoice_header__2j3Ng"};